
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["banner-icons",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"84","height":"87","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.229 18.562c0 8.507-6.96 15.468-15.468 15.468s-15.468-6.961-15.468-15.468c0-8.508 6.96-15.468 15.468-15.468 8.507 0 15.468 6.96 15.468 15.468zm3.093 0A18.517 18.517 0 0041.761 0a18.517 18.517 0 00-18.562 18.562 18.517 18.517 0 0018.562 18.561 18.517 18.517 0 0018.561-18.561z","fill":"#1B3067"}}),_c('path',{attrs:{"d":"M42.166 64.16c-20.641 1.464-29.815-9.778-31.727-20.44l1.53-1.174 1.146-.782h54.28l9.174 5.084 4.587 7.433v21.513c-.764 1.826.917 8.84 0 9.78-1.147 1.173-19.722-22.78-38.99-21.413z","fill":"#87A6D5"}}),_c('path',{attrs:{"d":"M18.558 63.418h-3.093V86.62h3.093V63.418zM68.062 63.418H64.97V86.62h3.093V63.418z","fill":"#1B3067"}}),_c('path',{attrs:{"d":"M18.562 43.31v-3.093A18.517 18.517 0 000 58.778v27.843h3.094V58.778c0-8.507 6.96-15.468 15.468-15.468zm64.965 43.31V58.779a18.517 18.517 0 00-18.561-18.561H18.562v3.093h46.404c8.507 0 15.468 6.961 15.468 15.468v27.843h3.093z","fill":"#1B3067"}})])
          )
        }
      }
    